import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page01',
  templateUrl: './armenia-page01.component.html',
  styleUrls: ['./armenia-page01.component.css']
})
export class ArmeniaPage01Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
